import { useState } from 'react';
import useFetch from '../../../../hooks/useFetch';
import { ServiceEvents } from '../../shared/interfaces';
import { buildEndpointIntranetAdmin } from '../../EndPoints';
import { Preference, PreferenceFilters } from '../../../models/Preference';

const usePreferenceService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetPreferences, setFetchingGetPreferences] = useState(false);
    const [fetchingShowPreference, setFetchingShowPreference] = useState(false);
    const [fetchingStorePreference, setFetchingStorePreference] = useState(false);
    const [fetchingEditPreference, setFetchingEditPreference] = useState(false);
    const [fetchingUpdatePreference, setFetchingUpdatePreference] = useState(false);
    const [fetchingDeletePreference, setFetchingDeletePreference] = useState(false);
    const [fetchingActivePreference, setFetchingActivePreference] = useState(false);

    const getPreferences = (bankFilters: PreferenceFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(bankFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        doGet({
            ...events,
            type: 'admin',
            url: `${buildEndpointIntranetAdmin('users/preferences')}?${queryString}`,
            setFetching: setFetchingGetPreferences
        });
    };

    const showPreference = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            type: 'admin',
            url: `${buildEndpointIntranetAdmin(`users/preferences/${id.toString()}/show`)}`,
            setFetching: setFetchingShowPreference
        });
    };

    const storePreference = (bank: Preference, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: `${buildEndpointIntranetAdmin(`users/preferences/store`)}`,
            type: 'admin',
            body: bank,
            setFetching: setFetchingStorePreference
        });
    };

    const editPreference = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            type: 'admin',
            url: `${buildEndpointIntranetAdmin(`users/preferences/${id.toString()}/edit`)}`,
            setFetching: setFetchingEditPreference
        });
    };

    const updatePreference = (id: number, bank: Preference, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            type: 'admin',
            url: `${buildEndpointIntranetAdmin(`users/preferences/${id.toString()}/update`)}`,
            body: bank,
            setFetching: setFetchingUpdatePreference
        });
    };

    const deletePreference = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            type: 'admin',
            url: `${buildEndpointIntranetAdmin(`users/preferences/${id.toString()}/delete`)}`,
            setFetching: setFetchingDeletePreference
        });
    };

    const activePreference = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            type: 'admin',
            url: `${buildEndpointIntranetAdmin(`users/preferences/${id.toString()}/active`)}`,
            body: { active: active },
            setFetching: setFetchingActivePreference
        });
    };

    return {
        fetchingGetPreferences,
        fetchingShowPreference,
        fetchingStorePreference,
        fetchingEditPreference,
        fetchingUpdatePreference,
        fetchingDeletePreference,
        fetchingActivePreference,
        getPreferences,
        showPreference,
        storePreference,
        editPreference,
        updatePreference,
        deletePreference,
        activePreference
    };
};

export default usePreferenceService;
